import { render, staticRenderFns } from "./RunProductCharacteristics.vue?vue&type=template&id=14943b68&"
import script from "./RunProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./RunProductCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./RunProductCharacteristics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports